export default "__VITE_ASSET__be0a704f__"